/* Keeps every cart count badge (sidebar Cart link, mobile header icon) in sync
   with the real cart, including after Add to cart and in the cart drawer. */
(function () {
  function paint(count) {
    document.querySelectorAll('[data-lushe-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart.item_count); })
      .catch(function () {});
  }

  // Dawn announces every cart change with this event
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // Cart changed in another tab, or page restored from the back button
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})();
